import { render } from "./NewCotizacionView.vue?vue&type=template&id=547f8495"
import script from "./NewCotizacionView.vue?vue&type=script&lang=js"
export * from "./NewCotizacionView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__